import React from "react";
import "./QptMobile.scss";

const metricRows = [
  { label: "Target", day: 4, week: 28, month: 124 },
  { label: "Acht", day: 3, week: 18, month: 79 },
  { label: "Gap", day: -1, week: -10, month: -45 },
  { label: "% Acht", day: "-25%", week: "-36%", month: "-36%" },
  { label: "Incentive Earned", day: 24, week: 144, month: 632 },
];

const overallRows = [
  { label: "QPT", day: 4, week: 28, month: 124 },
  { label: "APT", day: 3, week: 18, month: 79 },
  { label: "HPT", day: 4, week: 18, month: 40 },
  { label: "Sub Total", day: 11, week: 64, month: 243, highlight: true },
  { label: "Store Expenses", day: 4, week: 4, month: 4, highlight: true },
  { label: "Total PT", day: 7, week: 60, month: 239, highlight: true },
];

const MetricsTable = ({ title }) => (
  <section className="qpt-section">
    <h3 className="qpt-title">{title}</h3>
    <div className="qpt-table-wrap">
      <table className="qpt-table">
        <thead>
          <tr>
            <th>Parameter</th>
            <th>Day</th>
            <th>Week</th>
            <th>Month</th>
          </tr>
        </thead>
        <tbody>
          {metricRows.map((row) => (
            <tr key={`${title}-${row.label}`}>
              <td>{row.label}</td>
              <td>{row.day}</td>
              <td>{row.week}</td>
              <td>{row.month}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);

export default function QptMobile() {
  return (
    <div className="qpt-mobile-page">
      <div className="qpt-mobile-only">
        <MetricsTable title="Quantity" />
        <MetricsTable title="QPT" />
        <MetricsTable title="APT" />
        <MetricsTable title="HPT" />

        <section className="qpt-section">
          <h3 className="qpt-title">Overall PT</h3>
          <div className="qpt-table-wrap">
            <table className="qpt-table">
              <thead>
                <tr>
                  <th>KPIs</th>
                  <th>Day</th>
                  <th>Week</th>
                  <th>Week</th>
                </tr>
              </thead>
              <tbody>
                {overallRows.map((row) => (
                  <tr key={row.label} className={row.highlight ? "highlight-row" : ""}>
                    <td>{row.label}</td>
                    <td>{row.day}</td>
                    <td>{row.week}</td>
                    <td>{row.month}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <div className="qpt-desktop-only">
        <p>QPT is available only on mobile.</p>
      </div>
    </div>
  );
}
